import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons';

import * as St from './ArrowButton.styles';

type ArrowButtonProps = {
  direction: 'left' | 'right';
  handleClick: () => void;
  btnStyleProps?: React.CSSProperties;
  iconStyleProps?: React.CSSProperties;
  ariaProps?: React.AriaAttributes;
};

const ArrowButton = ({
  direction,
  handleClick,
  btnStyleProps,
  iconStyleProps,
  ariaProps,
}: ArrowButtonProps) => (
  <St.Container
    data-dir={direction}
    onClick={handleClick}
    $customBtnStyles={btnStyleProps}
    {...ariaProps}
  >
    <St.ArrowIcon
      component={() =>
        direction === 'left' ? <LeftCircleFilled /> : <RightCircleFilled />
      }
      $customIconStyles={iconStyleProps}
    />
  </St.Container>
);

export default ArrowButton;
